import styled from 'styled-components';

export const InfoWell = styled.div`
  display: flex;
  padding: 16px;
  background-color: #f2f4f6;
  border-radius: 5px;
  align-items: center;

  & > * + * {
    margin-left: 48px;
  }
`;
